import { createLink } from '@tanstack/react-router';
import { ComponentProps, forwardRef } from 'react';
import { DropdownItemContainer } from '@optimus-web/core';

const DropdownItemContainerLink = forwardRef((props: ComponentProps<typeof DropdownItemContainer>, ref) => (
    <DropdownItemContainer as="a" ref={ref} {...props}>
        {props.label}
    </DropdownItemContainer>
));

export const DropdownItemLink = createLink(DropdownItemContainerLink);
